import React, {useState} from 'react';
import { styled } from "styled-components";

const FaqItemElement = styled.div`
  padding-bottom: 0px;
  justify-content: space-between;
  align-items: flex-start;
  
  border-bottom: 1px solid #E0E0E0;
  
  .title {
    cursor: pointer;
    width: 100%;
    margin-top: 1rem;
    
    p {
      font-weight: 700;
    }
    
    button {
      font-size: 30px;
      border: 0px solid;
      background-color: #FFF;
      float: right;
      
      &:hover {
        background: #cfcfcf;
      }
    }
  }
  .body {
    padding-bottom: 10px;
    
    color: #6F6F6F;
    font-variant-numeric: lining-nums proportional-nums;
    font-family: Raleway;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
`;

const FaqItem = ({title, body}) => {
  const [showBody, setShowBody] = useState(false);

  return (
    <FaqItemElement>
      <div className='title' onClick={() => setShowBody(!showBody)}>
        <button>{showBody ? '-' : '+'}</button>
        <p>{title}</p>
      </div>
      {showBody && <div className='body'>{body}</div>}
    </FaqItemElement>
  );
};

export const Faq = ({ items }) => {
  return (
    <div>
      {items.map((item, id) => <FaqItem key={`faqItem_${id}`} title={item.title} body={item.answer} />)}
    </div>
  );
};
